import { Button } from '@mantine/core';
import { OnboardingRequestDetailModel } from '@uag/welcome-shared/src/api/models';
import { CompanyInformation } from '@uag/welcome-shared/src/components/company/ViewCompany/CompanyInformation';
import { RequestAttachments } from '@uag/welcome-shared/src/components/company/ViewCompany/RequestAttachments';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';

type Props = {
    request: OnboardingRequestDetailModel;
    className?: string;
    onClose?: () => void;
};

export const ViewCompany = ({ request, className, onClose }: Props) => {
    const { t } = useTranslation();

    return (
        <div className={clsx(className, 'flex w-full flex-col gap-4')}>
            <CompanyInformation mode="Frontend" request={request} />
            <RequestAttachments mode="Frontend" request={request} />
            {onClose && (
                <Button className="modal-action mt-2 ml-auto" onClick={onClose}>
                    {t('close')}
                </Button>
            )}
        </div>
    );
};
